// extracted by mini-css-extract-plugin
export default {"container":"PrefixTriggeredMenu-module__container--B1sol","small":"PrefixTriggeredMenu-module__small--bSzDk","reference":"PrefixTriggeredMenu-module__reference--mZpTw"};